import axios from 'axios';

const API = process.env.REACT_APP_API_BASE || 'http://127.0.0.1:8000';

function h() {
  const a = JSON.parse(localStorage.getItem('zocs_auth') || 'null');
  return a ? { Authorization: `Bearer ${a.token}` } : {};
}

export async function getCatalogueBatches() {
  return (await axios.get(`${API}/catalogue/batches`, { headers: h() })).data;
}

// body: { batches: [...] } or { all: true }
export async function importDesigns(body) {
  return (await axios.post(`${API}/catalogue/import`, body, { headers: h() })).data;
}

export async function listScrapes(params) {
  return (await axios.get(`${API}/catalogue/scrapes`, { headers: h(), params })).data;
}

export async function getScrape(designId) {
  return (await axios.get(`${API}/catalogue/scrapes/${designId}`, { headers: h() })).data;
}

export async function setScrapeLink(designId, productLink) {
  return (await axios.put(`${API}/catalogue/scrapes/${designId}/link`,
    { product_link: productLink }, { headers: h() })).data;
}

// scope: 'pending' | 'retry_failed' | 'selected'
// extra: { brand_id } for 'brand_all' / 'brand_remaining', { domain } for the domain scopes.
export async function startScrapeRun(scope, designIds = [], extra = {}) {
  return (await axios.post(`${API}/catalogue/runs`,
    { scope, design_ids: designIds, ...extra }, { headers: h() })).data;
}

// Every brand with designs in the catalogue, with designs per status.
export async function listCatalogueBrands() {
  return (await axios.get(`${API}/catalogue/brands`, { headers: h() })).data.brands;
}

// Every site the catalogue's links point at, with designs per status.
export async function listDomains() {
  return (await axios.get(`${API}/catalogue/domains`, { headers: h() })).data.domains;
}

export async function getLatestScrapeRun() {
  return (await axios.get(`${API}/catalogue/runs/latest`, { headers: h() })).data.run;
}

export async function stopScrapeRun(runId) {
  return (await axios.post(`${API}/catalogue/runs/${runId}/stop`, {}, { headers: h() })).data;
}

// The final catalogue (one row per variant); product_id is the design_id.
export async function getProduct(productId) {
  return (await axios.get(`${API}/catalogue/products/${productId}`, { headers: h() })).data;
}

export async function uploadProductImages(productId, files, onProgress) {
  const form = new FormData();
  files.forEach((f) => form.append('files', f));
  return (await axios.post(`${API}/catalogue/products/${productId}/images`, form, {
    headers: h(),
    onUploadProgress: (e) => onProgress && e.total && onProgress(Math.round((e.loaded / e.total) * 100)),
  })).data;
}

export async function removeProductImage(productId, url) {
  return (await axios.delete(`${API}/catalogue/products/${productId}/images`, { headers: h(), params: { url } })).data;
}

// Copy the scraped page's photos into S3 (all of them, or the urls given).
export async function copyPagePhotos(productId, urls = null) {
  return (await axios.post(`${API}/catalogue/products/${productId}/images/from-page`,
    urls ? { urls } : {}, { headers: h() })).data;
}

// New photo order for a product (every photo, the first is the cover).
export async function reorderProductImages(productId, urls) {
  return (await axios.put(`${API}/catalogue/products/${productId}/images/order`, { urls }, { headers: h() })).data;
}

// The background job that copies page photos for every scraped design.
export async function getCopyJob() {
  return (await axios.get(`${API}/catalogue/products/copy-job`, { headers: h() })).data;
}

export async function startCopyJob() {
  return (await axios.post(`${API}/catalogue/products/copy-job`, {}, { headers: h() })).data;
}

export function apiError(e, fallback = 'Something went wrong') {
  return e?.response?.data?.detail || e?.message || fallback;
}

// ── website classification (Catalogue > Attributes) ──────────────────────
const CLS = `${API}/catalogue/classification`;

export async function getTaxonomy() {
  return (await axios.get(`${API}/catalogue/taxonomy`, { headers: h() })).data;
}
export async function getClassificationSummary() {
  return (await axios.get(`${CLS}/summary`, { headers: h() })).data;
}
export async function listClassified(params) {
  return (await axios.get(`${CLS}/designs`, { headers: h(), params })).data;
}
export async function saveClassification(designId, body) {
  return (await axios.put(`${CLS}/designs/${designId}`, body, { headers: h() })).data;
}
export async function approveClassified(designIds) {
  return (await axios.post(`${CLS}/approve`, { design_ids: designIds }, { headers: h() })).data;
}
export async function getUnmapped() {
  return (await axios.get(`${CLS}/unmapped`, { headers: h() })).data;
}
export async function getMappings() {
  return (await axios.get(`${CLS}/mappings`, { headers: h() })).data.mappings;
}
// body: { field, raw_value, action: 'map' | 'ignore', target_value }
export async function saveMapping(body) {
  return (await axios.post(`${CLS}/mappings`, body, { headers: h() })).data;
}
export async function deleteMapping(id) {
  return (await axios.delete(`${CLS}/mappings/${id}`, { headers: h() })).data;
}
export async function getDefinitions() {
  return (await axios.get(`${CLS}/definitions`, { headers: h() })).data.definitions;
}
export async function saveDefinition(subcategory, definition) {
  return (await axios.put(`${CLS}/definitions`, { subcategory, definition }, { headers: h() })).data;
}
export async function getClassifyRun() {
  return (await axios.get(`${CLS}/run`, { headers: h() })).data.run;
}
export async function startClassifyRun() {
  return (await axios.post(`${CLS}/run`, {}, { headers: h() })).data;
}

// Website search, tried by staff (POST /catalogue-search/try). keyword_only ranks without Gemini.
export async function trySearch(body) {
  return (await axios.post(`${API}/catalogue-search/try`, body, { headers: h() })).data;
}

export async function getSearchStatus() {
  return (await axios.get(`${API}/catalogue-search/status`, { headers: h() })).data;
}
